import { SPage } from "src/components/spage";

interface IProps {}
export const MyOrdersPage = ({}: IProps) => {
  return <SPage title={"My Orders"}></SPage>;
};
